"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  learnAssign: {
    delAssgin: {
      delTip: 'Are you sure to delete',
      onBoard: 'On Board',
      unlearnNum: 'Number Of Not Learned',
      unlearnData: 'Unlearned data'
    },
    index: {
      filter: {
        processing: 'Processing',
        completed: 'Completed'
      },
      expired: 'Expired',
      tip: 'Note that multiple accounts are separated by commas',
      userAccount: 'User Account',
      shoreExam: 'exam required of shore',
      shipExam: 'exam required of ship',
      initFrom: 'Initiate From',
      initShore: 'Initiate From Shore',
      initShip: 'Initiate From Ship',
      taskType: 'Task Type',
      executedShip: 'Executed Ship',
      completionStatus: 'Completion Status',
      all: 'All',
      assignDept: 'Assigned By My Department',
      myAssign: 'My Assignment',
      learnTask: 'Learning Tasks',
      workTask: 'Work Tasks',
      assignType: 'Assignment Type',
      feedbackFlag: 'Feedback For Task(Shore)',
      vesselFeedbackFlag: 'Feedback For Task(Ship)',
      uploadAttach: 'Shore require Attachments',
      vesselUploadAttach: 'Ship require Attachments',
      taskRequirements: 'Task Requirements',
      taskAssignment: 'Task Assignment',
      company: 'Company',
      shorePostId: 'Task Of Shore Based',
      sysPostId: 'Task Of Ship',
      otherTasks: 'Other Tasks',
      applicableCompany: 'Applicable Company',
      roleMonitor: 'Monitor Post',
      monitoring: 'Task assignment and monitoring',
      questionsNumber: 'Number Of Test Questions',
      correct: 'Correct',
      incorrect: 'Incorrect',
      retest: 'Retest',
      submitExam: 'Submit',
      exam: 'Post Study Examination',
      startExam: 'Start Exam',
      confirmSubmit: 'Are you sure to submit the exam',
      confirmRetest: 'Are you sure to retest',
      addAssign: 'Add Assign',
      title: 'HSQEMS Learning ',
      item: 'Study Distribution',
      cancelMonitor: 'Cancel Monitor',
      query: {
        itemName: 'Item Name'
      },
      systemDocuments: 'Manual',
      companyNotice: 'Circulars',
      rulesCirculars: 'Rules & Circulars',
      externalRegulations: 'External DOC &',
      otherControlledDoc: 'Support Manual/Plan',
      bestImplementation: 'Best Practices',
      hasBeenLearning: 'Learned',
      didNotLearn: 'Unlearned',
      operationSuccessful: 'Operate Successfully',
      cancelLearnMission: 'Do you want to cancel the learning task of the selected person?',
      selectOne: 'Please select a record',
      qualityFileType: 'DOC. Type',
      qualityFileDate: 'Effective Date',
      today: 'Today',
      week: 'Week',
      mounth: 'Month',
      year: 'Year',
      operationFailure: 'Operate failed',
      table: {
        qualityFileNo: 'DOC. No.',
        qualityFileName: 'DOC. Name',
        qualityFileType: 'Type',
        assignDate: 'Assigned Date',
        learnDeadline: 'Learned Deadline',
        sysPersonId: 'Learner of shore based ',
        sysPostId: 'Learner of ship',
        vesselCode: 'Ship',
        learnDetail: 'Learned Summary',
        learnStatus: 'Learned Status',
        feedBackDetail: 'Feedback',
        personOrPost: 'Learner'
      },
      form: {
        yes: 'Y',
        no: 'N',
        qualityFileType: 'File Type',
        qualityFileName: 'DOC. Name',
        learnDeadline: 'Learned Deadline',
        feedbackFlag: 'Feedback for learned',
        sysPostId: 'Learner of shore based',
        sysShipId: 'Learner of ship',
        vesselCode: 'Ship',
        learnRemark: 'Learned requirement',
        assignTaskName: 'Task Name',
        assignName: 'Assigner',
        monitor: 'Monitor',
        vessel: 'Dept./Ship',
        position: 'Position/Rank',
        userName: 'Person Name',
        learnDeatil: 'Learning Situation',
        learnedDate: 'Learned Date',
        actual: 'Feedback',
        feedbackContext: 'Feedback description',
        reservedInt1: 'Situation',
        reservedDate: 'Date',
        reservedStr1: 'Reason',
        attachment: 'Attachment',
        feedbackShip: 'Ship',
        ship: 'Ship',
        dept: 'Dept.',
        learnFlag: 'Learning Situation'
      }
    },
    btn: {
      deleteUnlearnedData: 'Delete Unlearned Data'
    },
    msg: {
      operationSuc: 'Operation successful',
      operationFail: 'Operation failed',
      checkTask: 'Please add task before submitting'
    }
  }
};